/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { GridSpacing } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
	interface Theme {
		customDimensions: Dimensions;
	}
	// allow configuration using `createTheme`
	interface ThemeOptions {
		customDimensions?: Partial<Dimensions>;
	}
}

type Dimensions = {
	layoutSpacing: ResponsiveStyleValue<GridSpacing>;
	pdpTopWidgetsSpacing: ResponsiveStyleValue<GridSpacing>;
	myAccountCardSpacing: ResponsiveStyleValue<GridSpacing>;
};

export const dimensions: ThemeOptions = {
	customDimensions: {
		layoutSpacing: {
			xs: 2.5,
			sm: 2.5,
			md: 2.5,
			lg: 2.5,
		},
		pdpTopWidgetsSpacing: {
			xs: 2.5,
			sm: 2.5,
			md: 10,
			lg: 10,
		},
		myAccountCardSpacing: {
			xs: 4,
			sm: 4,
			md: 6,
			lg: 6
		}
	},
};